/*
  Lightweight canvas particle overlay for image-banner sections.
  Test feature: no WebGL, no external library, pure Canvas 2D.
  - Skips entirely if prefers-reduced-motion is set, or canvas isn't supported.
  - Pauses when the banner scrolls out of view to save battery/CPU.
  - Never blocks or replaces the real heading/text/button markup underneath.
*/
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initParticleCanvas(canvas) {
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return;

    var particles = [];
    var particleCount = 46;
    var maxLinkDistance = 130;
    var width = 0;
    var height = 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var running = false;
    var rafId = null;
    var seeded = false;
    var visible = false;
    var waitAttempts = 0;

    function applySize(w, h) {
      width = w;
      height = h;
      canvas.width = Math.max(1, Math.round(width * dpr));
      canvas.height = Math.max(1, Math.round(height * dpr));
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function makeParticle() {
      return {
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * 0.15,
        vy: (Math.random() - 0.5) * 0.15,
        r: Math.random() * 1.4 + 0.6
      };
    }

    function seed() {
      particles = [];
      for (var i = 0; i < particleCount; i++) particles.push(makeParticle());
    }

    function step() {
      if (!running) return;
      ctx.clearRect(0, 0, width, height);

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > width) p.vx *= -1;
        if (p.y < 0 || p.y > height) p.vy *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,0.55)';
        ctx.fill();
      }

      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var dx = particles[a].x - particles[b].x;
          var dy = particles[a].y - particles[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < maxLinkDistance) {
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.strokeStyle = 'rgba(255,255,255,' + (0.18 * (1 - dist / maxLinkDistance)) + ')';
            ctx.lineWidth = 0.6;
            ctx.stroke();
          }
        }
      }

      rafId = window.requestAnimationFrame(step);
    }

    function start() {
      if (running) return;
      running = true;
      rafId = window.requestAnimationFrame(step);
    }

    function stop() {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
    }

    function tryInit() {
      var rect = canvas.parentElement.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        applySize(rect.width, rect.height);
        seeded = true;
        seed();
        if (visible) start();
        return;
      }
      waitAttempts++;
      if (waitAttempts < 240) {
        window.requestAnimationFrame(tryInit);
      }
    }

    tryInit();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        var rect = canvas.parentElement.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          applySize(rect.width, rect.height);
          seed();
        }
      }, 200);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible && seeded) start();
            else stop();
          });
        },
        { threshold: 0.05 }
      );
      observer.observe(canvas.parentElement);
    } else {
      visible = true;
      if (seeded) start();
    }
  }

  function init() {
    var canvases = document.querySelectorAll('[data-hero-particles]');
    canvases.forEach(function (canvas) {
      try {
        initParticleCanvas(canvas);
      } catch (e) {
        // Fail silently: the static image and text underneath already work fine.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
